<template>
  <div :class="[$style.account, commonStore.isWebView && $style.webview]">
    <div :class="$style.accountName">
      <a href="/account">
        <img v-if="userStore.picturePath" :src="dynamicImageUrl(userStore.picturePath, 100, 100)" alt="" width="50" height="50" />
        <div :class="$style.accountNameText">
          <p :class="$style.name">{{ userStore.memberName }}</p>
          <ShopStatusVacation v-if="isSeller && shopStore.isOnVacation" />
          <p v-else :class="$style.mypage">マイページ</p>
        </div>
      </a>
    </div>
    <div :class="$style.accountMenu">
      <ul>
        <li>
          <a v-if="isSeller" :href="`/shop/${userStore.aliasOrSlug}`">ショップを見る</a>
          <a v-else :href="`/people/${userStore.aliasOrSlug}`">プロフィールを見る</a>
        </li>
        <li>
          <a href="/account/todo"
            >やることリスト<span v-if="todoStore.totalCount > 0" :class="$style.updated">{{ omitWithCap(todoStore.totalCount) }}</span></a
          >
        </li>
        <li>
          <a href="/account/notification"
            >お知らせ<span v-if="notificationStore.updatedCount > 0" :class="$style.updated">{{ omitWithCap(notificationStore.updatedCount) }}</span></a
          >
        </li>
      </ul>
      <ul v-if="isSeller">
        <li><a href="/your/item/create">作品登録</a></li>
        <li><a href="/your/items">作品管理</a></li>
        <li><a href="/your/orders">受注管理</a></li>
        <li><a href="/your/analysis">アクセス解析</a></li>
        <li><a href="/your/sales">売上・入金</a></li>
      </ul>
      <ul v-if="isPromoter">
        <li><a href="/your/event/create">イベント登録</a></li>
        <li><a href="/your/events">イベント管理</a></li>
      </ul>
      <ul>
        <li><a href="/your/purchases">購入履歴</a></li>
        <li>
          <a href="/conversations"
            >メッセージ<span v-if="messageStore.unreadCount > 0" :class="$style.updated">{{ omitWithCap(messageStore.unreadCount) }}</span></a
          >
        </li>
        <li><a href="/your/settings">設定</a></li>
      </ul>
      <ul>
        <li v-if="commonStore.isWebView"><a href="https://help.iichi.com/hc/ja/">ヘルプ</a></li>
        <li><a href="/signout">ログアウト</a></li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { omitWithCap } from '@/js/lib/helper/number';
import { dynamicImageUrl } from '@/js/lib/helper/url';
import { credentials } from '@/js/lib/api/user';
import { useCommonStore } from '@/js/lib/store/common';
import { useMessageStore } from '@/js/lib/store/message';
import { useNotificationStore } from '@/js/lib/store/notification';
import { useShopStore } from '@/js/lib/store/shop';
import { useTimelineStore } from '@/js/lib/store/timeline';
import { useTodoStore } from '@/js/lib/store/todo';
import { useUserStore } from '@/js/lib/store/user';
import ShopStatusVacation from '@/js/components/organisms/ShopStatusVacation.vue';

const commonStore = useCommonStore();
const userStore = useUserStore();
const shopStore = useShopStore();
const notificationStore = useNotificationStore();
const todoStore = useTodoStore();
const messageStore = useMessageStore();
const timelineStore = useTimelineStore();
const isPromoter = userStore.hasCredential(credentials.promoter);
const isSeller = userStore.hasCredential(credentials.seller);

onMounted(() => {
  if (userStore.isAuthenticated) {
    messageStore.checkUnreadCount();
    notificationStore.checkUpdated();
    timelineStore.checkItemUpdated();
    timelineStore.checkEventUpdated();
  }
});
</script>

<style module lang="scss">
.account {
  background-color: var(--color-white);
  border: 1px solid $border-color;
  position: absolute;
  right: -76px;
  top: 40px;
  width: 300px;
  z-index: 1001;

  &.webview {
    position: static;
  }

  @media (--sp) {
    border-left: none;
    border-right: none;
    box-shadow: 0 2px 2px 0 var(--color-black-alpha10);
    left: 0;
    right: auto;
    top: 53px;
    width: 100%;

    &.webview {
      border-top: none;
      box-shadow: none;
    }
  }

  .accountName {
    > a {
      display: flex;
      padding: 16px;

      &:hover {
        background: var(--color-gray100);
        text-decoration: none;
      }
    }

    img {
      border-radius: 50%;
      flex-grow: 0;
      height: 50px;
      width: 50px;
    }

    .accountNameText {
      flex: 1;
      overflow: hidden;
      padding-left: 15px;

      a:hover {
        text-decoration: underline;
      }

      .name {
        font-weight: bold;
        margin-bottom: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        white-space: nowrap;
      }

      .mypage {
        margin-bottom: 0;
      }
    }
  }

  .accountMenu {
    background-color: var(--color-white);

    > ul {
      border-top: 1px solid $border-color;
      padding: 8px;

      li a {
        display: block;
        padding: 6px 8px;

        &:hover {
          background: var(--color-gray100);
          text-decoration: none;
        }

        .updated {
          background: var(--color-red);
          border-radius: 2px;
          color: var(--color-white);
          display: inline-block;
          font-size: 10px;
          font-weight: bold;
          line-height: 12px;
          margin-left: 6px;
          padding: 2px 4px;
          position: relative;
          top: -2px;
        }
      }
    }
  }
}
</style>
